import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { authApiService } from "../../../../api/api";
import { ReactComponent as RowIcon } from "../../../../assets/icons/warehouse/row.svg";
import { IBatcherProduct, IProduct } from "../../../../types/product.type";
import { formatDate } from "../../../../utils/formatDate";
import BlueButton from "../../../buttons/BlueButton/BlueButton";
import GreenLinkButton from "../../../buttons/GreenLinkButton/GreenLinkButton";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";

interface Props {
  warehouse: IProduct;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewWarehouseForm: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const [editBatcher, setEditBatcher] = useState<IBatcherProduct | null>(null);

  const onClickDelete = async (id: string) => {
    try {
      const response = await authApiService.deleteBatch(id);
      if (response) {
        setEditBatcher(null);
        props.onPressEdit();
        return;
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err.response.data.message);
    }
  };

  const onClickSave = async (id: string, batch: IBatcherProduct) => {
    try {
      const body = {
        batchName: batch.batchName,
        batchQuantity: batch.batchQuantity,
        batchPrice: Number(batch.batchPrice),
        batchDate: batch.batchDate,
      };
      const response = await authApiService.updateBatch(id, body);
      if (response) {
        setEditBatcher(null);
        props.onPressEdit();
        return;
      }
    } catch (err: any) {
      console.error(err);
      toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      {editBatcher ? (
        <>
          <div className={styles.form}>
            <EditInput
              value={editBatcher.batchName}
              title="Batch"
              setValue={(value) => {
                const newState = { ...editBatcher };
                newState.batchName = value;
                setEditBatcher(newState);
              }}
              isRequired={false}
            />
            <div className={styles.subContainer}>
              <EditInput
                value={editBatcher.batchQuantity.toString()}
                title="Batch"
                setValue={(value) => {
                  if (isNaN(Number(value))) {
                    toast.error("Field value must be a number");
                    return;
                  }
                  const newState = { ...editBatcher };
                  newState.batchQuantity = Number(value);
                  setEditBatcher(newState);
                }}
                isRequired={false}
              />
              <EditInput
                value={editBatcher.batchPrice}
                title="Batch price"
                setValue={(value) => {
                  if (isNaN(Number(value))) {
                    toast.error("Field value must be a number");
                    return;
                  }
                  const newState = { ...editBatcher };
                  newState.batchPrice = value;
                  setEditBatcher(newState);
                }}
                isRequired={false}
              />
              <DatePicker
                selected={editBatcher.batchDate}
                onChange={(value) => {
                  if (value) {
                    const newState = { ...editBatcher };
                    newState.batchDate = value;
                    setEditBatcher(newState);
                  }
                }}
                className={styles.dateInput}
                onFocus={(e) => e.target.blur()}
              />
            </div>
          </div>
          <ModalBottomButtons
            backTitle="Delete"
            onPressBack={() => onClickDelete(editBatcher.id)}
            applyTitle="Save"
            onPressApply={() => onClickSave(editBatcher.id, editBatcher)}
            isDeleteBackButton
          />
        </>
      ) : (
        <>
          <div className={styles.form}>
            <GreenLinkButton
              title="Вибраний ресурс"
              buttonTitle={`${props.warehouse.name}, ${props.warehouse.capacity}`}
              onClick={() => {
                // navigate({
                //   pathname: "/resources",
                //   search: `?item=${props.warehouse.id}`,
                // });
              }}
            >
              <RowIcon />
            </GreenLinkButton>

            <ViewInput title="Brand" value={props.warehouse.brand.name} />
            {props.warehouse.batches
              .filter((item) => item.batchQuantity > 0)
              .map((item, index) => (
                <>
                  <br />
                  <ViewInput title="Batch" value={item.batchName} />
                  <div className={styles.subContainer}>
                    <ViewInput
                      title="Count"
                      value={item.batchQuantity.toString()}
                    />
                    <ViewInput
                      title="Date"
                      value={formatDate(item.batchDate)}
                    />
                    <ViewInput
                      title="Batch price"
                      value={item.batchPrice.toString()}
                    />
                  </div>
                  <BlueButton
                    onClick={() => setEditBatcher(item)}
                    title="Edit"
                    isBigButton
                  />
                </>
              ))}
          </div>
          <ModalBottomButtons
            backTitle="Назад"
            onPressBack={props.onClose}
            applyTitle="Редагувати"
          />
        </>
      )}
    </div>
  );
};

export default ViewWarehouseForm;
